import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Strings from '../../../i18n';
import { selectedLocationsByUser } from '../../../store/slices/locations/location';
import {
  useAssignLocationToOrganizationMutation,
  useDeleteLocationInOrganizationMutation,
  useGetLocationsMutation,
  useGetOrganizationLocationsMutation
} from '../../../services/device/deviceService';
import { AssignLocationToOrgProps } from './assignLocationToOrgProps';
import { LocationByUser } from '../../../types/location/location';
import { filterLocations } from '../../../utils/locations';
import { selectSystemOrganizationsReadWrite } from '../../../store/slices/systemPermissions/systemPermissions';
import {
  ButtonStyled,
  ButtonStyledCancel,
  ButtonsContainer,
  InputStyled,
  TitleStyled,
  noBorderStyle
} from '../../device/addDeviceToLocation/addDeviceToLocationStyles';
import { colors } from '../../../constants/colors';
import { ItemLocationSelected } from '../../../components/itemLocationSelected/itemLocationSelected';
import { setOpenOrganizationSideBar } from '../../../store/slices/app/app';

export const AssignLocationToOrg = ({
  idOrganization
}: AssignLocationToOrgProps) => {
  const permissionReadWrite = useSelector(selectSystemOrganizationsReadWrite);
  const locations = useSelector(selectedLocationsByUser);
  const [filterText, setFilterText] = useState('');
  const [
    getAllLocations,
    { isSuccess: isSuccessAllLocations, data: dataLocations }
  ] = useGetLocationsMutation();
  const [locationUserFiltered, setLocationUserFiltered] = useState<
    LocationByUser[]
  >([]);
  const [preLimit, setPreLimit] = useState(0);
  const [beforeLimit, setBeforeLimit] = useState(5);
  const [locationSelected, setLocationSelected] = useState(0);
  const dispatch = useDispatch();
  const [addLocationToOrganization, { isSuccess }] =
    useAssignLocationToOrganizationMutation();
  const [deleteLocationInOrganization, { isSuccess: isSuccessDeleteLocation }] =
    useDeleteLocationInOrganizationMutation();
  const [getLocations, { data, isSuccess: isSuccessLocations }] =
    useGetOrganizationLocationsMutation();
  useEffect(() => {
    if (idOrganization) {
      getLocations(idOrganization.toString());
      getAllLocations('');
    }
  }, []);

  useEffect(() => {
    if (isSuccessLocations && data) {
      setLocationUserFiltered(filterLocations(locations, data));
    }
  }, [isSuccessLocations]);
  const [expanded, setExpanded] = React.useState<string | false>(false);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  useEffect(() => {
    if (isSuccess) {
      toast.success(Strings.locations.successAddedLocations);
      getLocations(idOrganization.toString());
    }
  }, [isSuccess]);

  useEffect(() => {
    if (isSuccessDeleteLocation) {
      toast.success(Strings.locations.successDeleteLocations);
      getLocations(idOrganization.toString());
    }
  }, [isSuccessDeleteLocation]);
  const filteredItems = dataLocations?.filter(
    (item) =>
      JSON.stringify(item).toLowerCase().indexOf(filterText.toLowerCase()) !==
      -1
  );
  const postLocationToOrg = (locationId: number) => {
    addLocationToOrganization({
      OrganizationId: idOrganization,
      locationIds: [locationId]
    });
  };

  const items = filterText.length ? filteredItems : dataLocations;
  return (
    <Box height="100%">
      <TitleStyled variant="h5">
        {Strings.locations.assignOrganizationTitle}
      </TitleStyled>
      <Box
        height="100%"
        bgcolor={colors.white}
        padding={2}
        marginTop={3}
        borderRadius={2}
      >
        <Grid direction="row" container>
          <Typography
            fontSize={13}
            color={colors.darkGray}
            marginTop={1}
            marginLeft={2}
          >
            {Strings.locations.searchByNameOwnerAddress}
          </Typography>
          <Grid
            item
            xs={12}
            bgcolor={colors.lightGray}
            padding={1}
            borderRadius={2}
          >
            <InputStyled
              sx={noBorderStyle}
              fullWidth
              onChange={(e) => setFilterText(e.target.value)}
            />

            {items &&
              items.slice(preLimit, beforeLimit).map((loc) => (
                <ItemLocationSelected
                  selected={'id' in loc && loc.id === locationSelected}
                  action={() => {
                    if ('id' in loc) {
                      setLocationSelected(loc.id);
                    }
                  }}
                  locationName={'name' in loc ? loc.name : ''}
                  ownerName=""
                />
              ))}
          </Grid>
          <Grid
            item
            container
            justifyContent="flex-end"
            marginTop={1}
            marginBottom={1}
          >
            <ButtonStyledCancel
              disabled={preLimit === 0 && beforeLimit === 5}
              variant="contained"
              size="small"
              onClick={() => {
                setPreLimit((prev) => prev - 5);
                setBeforeLimit((prev) => prev - 5);
              }}
            >
              {Strings.common.previous}
            </ButtonStyledCancel>
            <ButtonStyled
              disabled={items && items?.length <= beforeLimit}
              onClick={() => {
                setPreLimit((prev) => prev + 5);
                setBeforeLimit((prev) => prev + 5);
              }}
              variant="contained"
              size="small"
            >
              {Strings.common.next}
            </ButtonStyled>
          </Grid>
        </Grid>
        <ButtonsContainer height="10%">
          <ButtonStyledCancel
            variant="contained"
            size="large"
            onClick={() => {
              dispatch(setOpenOrganizationSideBar(false));
            }}
          >
            {Strings.common.cancel}
          </ButtonStyledCancel>
          <ButtonStyled
            onClick={() => postLocationToOrg(locationSelected)}
            disabled={!locationSelected}
            variant="contained"
            size="large"
          >
            {Strings.common.select}
          </ButtonStyled>
        </ButtonsContainer>
      </Box>
    </Box>
  );
};
